import { message } from "antd";
import { api } from "../../../../../app/baseQuery";
import {
  IAllInvoices,
  IViewInvoiceDetails,
} from "../../../../../common/types/commonInterfaces";
import {
  HTTPResponse,
  voidType,
} from "../../../../../common/types/commonTypes";
import { MONEY_RECEIPT_TAG } from "../../../../Money_Receipt/api/endpoints/moneyReceiptEndpoints";
import { INVALIDATE_CLIENT_VENDOR_LEDGER } from "../../../../Reports/Api/constants";
import { INVOICE_HAJJ } from "../constants/constants";
import { InvoiceHajjEndPointType } from "../../../Invoice_Hajj/Types/InvoiceHajjTypes";
import {
  IHajjRefundData,
  IHajjRefundInfoDetails,
  InvoiceHajjType,
  ISubmitHajjRefundData,
} from "../../types/InvoiceHajjTypes";
import { IInvoicePreRegHajiInfo } from "../../../../Invoice(Visa)/Type/invoiceVisa.interface";
import { IFinalHajiInfo } from "../../types/packageRateTypes";

export const packageRateEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    // GET ALL
    getAllIPackageRate: build.query<HTTPResponse<IAllInvoices[]>, string>({
      query: (query) => ({
        url: `/invoice_package_rate/all/83/?${query}`,
      }),
      providesTags: () => [
        "invoices",
        INVOICE_HAJJ,
        { type: MONEY_RECEIPT_TAG },
      ],
    }),

    // VIEW DETAILIS
    getSinglePackRate: build.query<HTTPResponse<IViewInvoiceDetails>, number>({
      query: (id) => ({
        url: `/invoice_package_rate/view/${id}`,
      }),
      providesTags: () => [INVOICE_HAJJ, "invoices", "invoice_single_view"],
    }),

    // DELETE AND RESTORE
    deleteInvoiceHajj: build.mutation<
      HTTPResponse<void>,
      { query: "delete" | "restore"; user_id?: number; id: number }
    >({
      query: ({ id, query, user_id }) => ({
        url: `/invoice_package_rate/${query}/${id}`,
        method: "DELETE",
        body: { invoice_has_deleted_by: user_id },
      }),
      invalidatesTags: [
        "invoices",
        INVOICE_HAJJ,
        INVALIDATE_CLIENT_VENDOR_LEDGER,
      ],
    }),

    // get invoice number
    getHajjInvioceNo: build.query<HTTPResponse<string>, void>({
      query: () => ({
        url: "/invoice_package_rate/ih-invoiceno",
      }),
      providesTags: () => [{ type: INVOICE_HAJJ }],
    }),
    // invoice hajj post
    CreatePackageRate: build.mutation<
      HTTPResponse<void>,
      { body: InvoiceHajjEndPointType }
    >({
      query: ({ body }) => ({
        url: `/invoice_package_rate/post`,
        method: "POST",
        body,
      }),
      invalidatesTags: [
        "final-haji",
        { type: INVOICE_HAJJ },
        INVALIDATE_CLIENT_VENDOR_LEDGER,
      ],
    }),

    packageRateEdit: build.mutation<
      HTTPResponse<void>,
      { body: InvoiceHajjEndPointType; id?: string }
    >({
      query: ({ body, id }) => {
        console.log(id);
        return {
          url: `/invoice_package_rate/edit/${id}`,
          method: "PATCH",
          body,
        };
      },
      invalidatesTags: [
        { type: INVOICE_HAJJ },
        INVALIDATE_CLIENT_VENDOR_LEDGER,
      ],
    }),

    packageRateGetForEdit: build.query<
      HTTPResponse<InvoiceHajjType>,
      { id: number }
    >({
      query: ({ id }) => ({
        url: `/invoice_package_rate/get-for-edit/${id}`,
      }),
      providesTags: () => [{ type: INVOICE_HAJJ }],
    }),

    // Void Invoice Hajj
    voidHajjInvoiceTicket: build.mutation<HTTPResponse<void>, voidType>({
      query: (body) => ({
        url: `/invoice_package_rate/void/${body.id}`,
        method: "PUT",
        body: body,
      }),

      transformErrorResponse: (response) => {
        if (response.status === 400 && response.data) {
          const { message: err } = response.data as {
            message: string;
            success: boolean;
          };
          message.error(`${err}`);
        } else {
          message.error("Some things went to wrong");
        }
      },
      onQueryStarted: async (arg, { queryFulfilled }) => {
        await queryFulfilled;
        message.success("Void Successfully");
      },

      invalidatesTags: [
        "invoices",
        "invoice-hajji",
        INVALIDATE_CLIENT_VENDOR_LEDGER,
      ],
    }),

    // INVOICE HAJJ REFUND ENDPOINTS ----------------
    invoiceHajjGetForRefundData: build.query<
      HTTPResponse<IHajjRefundData[]>,
      { id: string | number }
    >({
      query: ({ id }) => ({
        url: `/invoice_package_rate/billing_info/${id}`,
      }),
      providesTags: () => [{ type: INVOICE_HAJJ }],
    }),

    postInvoiceHajjGetForRefundData: build.mutation<
      HTTPResponse<void>,
      ISubmitHajjRefundData
    >({
      query: (body) => ({
        url: `/invoice_package_rate/refund`,
        body: body,
        method: "POST",
      }),
      invalidatesTags: () => [{ type: INVOICE_HAJJ }, { type: "TaxRefund" }],
    }),

    hajjRefundDetails: build.query<
      HTTPResponse<IHajjRefundInfoDetails>,
      string | undefined
    >({
      query: (id) => ({
        url: `/invoice_package_rate/refund/${id}`,
        method: "GET",
      }),
      providesTags: [{ type: INVOICE_HAJJ }],
    }),
    getFinalRegHajjiInfo: build.query<HTTPResponse<IFinalHajiInfo[]>, number>({
      query: (clientID) => ({
        url: `/invoice_package_rate/final_haji_tracking/${clientID}`,
      }),
      providesTags: () => [
        "final-haji",
        { type: INVOICE_HAJJ },
        INVALIDATE_CLIENT_VENDOR_LEDGER,
      ],
    }),
  }),
});

export const {
  useGetHajjInvioceNoQuery,
  useCreatePackageRateMutation,
  useLazyPackageRateGetForEditQuery,
  usePackageRateEditMutation,
  useGetAllIPackageRateQuery,
  useLazyGetAllIPackageRateQuery,
  useGetSinglePackRateQuery,
  useDeleteInvoiceHajjMutation,
  useVoidHajjInvoiceTicketMutation,
  useInvoiceHajjGetForRefundDataQuery,
  usePostInvoiceHajjGetForRefundDataMutation,
  useHajjRefundDetailsQuery,
  useGetFinalRegHajjiInfoQuery,
} = packageRateEndpoints;
